<template>
  <div class="h100-40 h-scroll">
    <ejs-grid
      ref="grid"
      height="calc(100% - 0px)"
      :dataSource="data"
      :allowReordering="true"
      :allowResizing="true"
    >
      <e-columns :columns='shipColumns' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'>
        <e-column field='name' minWidth='10' :headerText='$t("NSMF.instanceSliceProfileName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sST' minWidth='10' :headerText='$t("NSMF.sst")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='sSTFormat'></e-column>
        <e-column field='sd' minWidth='10' :headerText='$t("NSMF.sd")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'  :formatter='sdFormat'></e-column>
        <e-column field='mcc' minWidth='10' :headerText='$t("NSMF.mcc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mccFormat'></e-column>
        <e-column field='mnc' minWidth='10' :headerText='$t("NSMF.mnc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mncFormat'></e-column>
        <e-column field='networkSliceName' minWidth='10' :headerText='$t("NSMF.instanceName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neConfig' minWidth='10' :headerText='$t("NSMF.neDeploy")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='namespace' minWidth='10' :headerText='$t("NSMF.namespace")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager
      ref="pager"
      @click="getNSSIListData()"
      :pageSize="page.pageSize"
      :currentPage="page.pageNo"
      :totalRecordsCount="page.totalCount"
      :pageCount="page.pageCount"
    ></ejs-pager>
    <CustomDialog
      ref="editLicenseDialog"
      :element="dialog.element.editLicenseDialogSetting"
      :styles="dialog.element.editLicenseDialogSetting.styles"
    >
      <template v-slot:dialog-content>
        <EditLicenseDialog ref="editLicenseContent"></EditLicenseDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import {
  Reorder,
  Resize,
  ExcelExport,
  ContextMenu
} from "@syncfusion/ej2-vue-grids";
import CustomDialog from "../../common/CustomDialog";
import EditLicenseDialog from "./dialog/EditLicenseDialog";
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "nssiTable",
  components: {
    CustomDialog,
    EditLicenseDialog
  },
  data() {
    return {
      data: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },
      shipColumns: [
        {
          field: "ShippedDate",
          headerText: "Shipped Date",
          format: "yMd",
          textAlign: "Right",
          width: 150,
          minWidth: 10
        },
        {
          field: "ShipCountry",
          headerText: "Ship Country",
          width: 150,
          minWidth: 10
        }
      ],
      dialog: {
        element: {
          editLicenseDialogSetting: {
            styles: {
              width: "860px",
              height: "717px",
              model: true,
              visible: false
            },
            target: "#app",
            title: this.$t("NSMF.editLicense"),
            refName: "edit",
            isClose: true,
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              },
              {
                click: this.saveEditLicense,
                buttonModel: {
                  content: this.$t("Common.confirm"),
                  isPrimary: true
                }
              }
            ]
          }
        }
      },
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu]
  },
  methods: {
    sSTFormat(grids, data) {
      if (null !== data && undefined !== data && null !== data.sNSSAIList) {
        let sstSource = data.sNSSAIList.split(":")[0];
        if (sstSource === "1") {
          return "eMBB";
        } else if (sstSource === "2") {
          return "URLLC";
        } else if (sstSource === "3") {
          return "MIoT";
        } else if (sstSource === "4") {
          return "V2X";
        }
      } else {
        return "";
      }
    },

    mccFormat(grids, data) {
      return data.pLMNList.split(":")[0];
    },
    mncFormat(grids, data) {
      return data.pLMNList.split(":")[1];
    },
    sdFormat(grids, data) {
      return data.sNSSAIList.split(":")[1];
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.no_checked")}`
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.too_many_checked")}!`
        });
        return false;
      }
      return selectedRecords;
    },
    getNSSIListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      const params = {
        pageNo: parseInt(This.page.pageNo, 10),
        pageSize: parseInt(This.page.pageSize, 10)
      };
      This.$axios
        .get(
          `/lte/ems/networkSlice/listServiceSliceSubnet?pageNo=${params.pageNo}&pageSize=${params.pageSize}`
        )
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            const result = response.data.resultVal;
            This.page.totalCount = result.totalCount;
            This.data = result.result;
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString
            });
          }
        });
    },
    deleteNSSI() {
      // 删除任务
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$layer.confirm({
          msg: this.$t("NSMF.deleteNSSI"),
          btn1: { msg: this.$t("Common.cancel") },
          btn2: {
            msg: this.$t("Common.confirm"),
            func: () => {
              this.$loading.showLoadding(this.$t('DeployManagement.deleteLoad'));
              this.$axios
                .post(
                  `/lte/ems/networkSlice/deleteNSSI/${checkedData.id}`
                )
                .then(response => {
                  if (
                    response &&
                    response.status === 200 &&
                    response.data.errorCode === "SUCCESS"
                  ) {
                    EventBus.$emit("toast", {
                      type: "success",
                      content: this.$t("Common.tips.success")
                    });
                    this.getNSSIListData();
                  } else {
                    EventBus.$emit("toast", {
                      type: "error",
                      content: response.data.errorString
                    });
                  }
                    this.$loading.hideLoadding();

                }).catch(err => {
               this.$loading.hideLoadding();
               EventBus.$emit("toast", {type: "warning",content: `${this.$t("Common.tips.failure")}`});                
                });
            }
          }
        });
      }
    },
    dialogHide() {
      this.$refs.editLicenseDialog.clear();
      this.$refs.editLicenseDialog.close();
    },
    editLicenseDialog() {
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$refs.editLicenseContent.loadNeForm(checkedData);
        this.$refs.editLicenseDialog.show();
      }
    },
    saveEditLicense(){
      const licenseData=this.$refs.editLicenseContent.getFormData();
      this.$axios
        .post(`/lte/ems/networkSlice/changeNissControl`, licenseData)
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            EventBus.$emit("toast", {
              type: "success",
              content: this.$t("Common.tips.success")
            });
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString
            });
          }
        });
        this.dialogHide();
    },
  },
  mounted() {
    this.getNSSIListData();
  }
};
</script>
